/**
 * Tell angular to run in development mode (with debug info) when protocol is http instead of https
 * @param {Object} $compileProvider
 */
export function setDebugMode($compileProvider) {
	'ngInject';
	// enable Angular debug info for local dev
	$compileProvider.debugInfoEnabled(window.IS_LOCAL_INSTALL);
}
